"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ModalComponent_1 = require("@CommonFrontend/Modal/ModalComponent");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("collaborator-invite-modal");
function RequestQwilrInvite(_a) {
    var closeModal = _a.closeModal;
    return (react_1.default.createElement(ModalComponent_1.Modal, { className: c() },
        react_1.default.createElement("div", { className: "confirm-modal" },
            react_1.default.createElement("img", { className: c("image"), src: "/Public/Assets/Images/collaborator-invite.png", alt: "An admin inviting a new user to the Qwilr dashboard" }),
            react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "3", className: c("heading") }, "Request a Qwilr invite"),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s" },
                "Contact your administrator to request an invite. Once invited you can edit, comment, and view analytics for pages in the account. ",
                react_1.default.createElement(kaleidoscope_1.Link, { href: "https://qwilr.com/login" }, "Sign in"),
                " if you already have an account."),
            react_1.default.createElement("div", { className: c("buttons") },
                react_1.default.createElement(kaleidoscope_1.Button, { href: function () { return "https://qwilr.com/"; }, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Large }, "What's Qwilr?"),
                react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Large, type: kaleidoscope_1.ButtonType.Primary, onClick: closeModal },
                    react_1.default.createElement(icons_1.ThumbsUp, null),
                    " Got it")))));
}
exports.default = RequestQwilrInvite;
